<div class="field-container" [formGroup]="formGroup">
  <ng-container *ngIf="blnRenderText">
    <label class="{{ labelName }}">
      <span class="label {{ labelName }} field-label">{{ labelName }}</span>
      <!-- (blur)="checkIfValid()" -->
      <input class="form-control"
       [ngClass]="{
        'form-control-login-screen': placeholderName == 'Enter your username' || placeholderName == 'Enter your password'
      }" [size]="txtFieldSize" [maxlength]="maxLength" [formControlName]="controlName" [placeholder]="placeholderName" (blur)="checkIfValid()"
        [type]="fieldType" [ngClass]="{
          'border-error': blnShowError || triggerError
        }">
    </label>
  </ng-container>
  <ng-container *ngIf="blnPrimePhone">
    <label>
      <input id="tel" #tel phoneMask [preValue]="getCurrentValue()" [phoneControl]="getCurrentControl()" placeholder=" "
        [size]="txtFieldSize" [formControlName]="controlName" (blur)="checkIfValid()" [type]="fieldType" [ngClass]="{
          'border-error': blnShowError || triggerError
        }">
      <span class="label"> {{ labelName }}</span>
    </label>
  </ng-container>
  <ng-container *ngIf="blnZipCodeMask">
    <label>
      <input id="zipMask" #zipMask zipCodeMask [numLen]="6" [preValue]="getCurrentValue()"
        [phoneControl]="getCurrentControl()" placeholder=" " [size]="txtFieldSize" [formControlName]="controlName"
        (blur)="checkIfValid()" [type]="fieldType" [ngClass]="{
          'border-error': blnShowError || triggerError
        }">
      <span class="label"> {{ labelName }}</span>
    </label>
  </ng-container>
  <ng-container *ngIf="blnNumLimitMask">
    <label>
      <input numLimitMask [numLen]="fieldLen" [preValue]="getCurrentValue()" [phoneControl]="getCurrentControl()"
        placeholder=" " [size]="txtFieldSize" [formControlName]="controlName" (blur)="checkIfValid()" [type]="fieldType"
        (metLimit)="nextFocus($event)" [ngClass]="{
          'border-error': blnShowError || triggerError
        }">
      <span class="label"> {{ labelName }}</span>
    </label>
  </ng-container>
  <ng-container *ngIf="blnCheckPassword">
    <label class="{{ labelName }}">
      <input placeholder=" " id="chkPassword" [size]="txtFieldSize" [formControlName]="controlName" [type]="fieldType"
        (keyup)="onCheckPassword($event)" [ngClass]="{
        'border-error': blnShowError || triggerError,
        'border-green': blnFieldGreen
      }">
      <span class="label">{{ labelName }}</span>
      <span *ngIf="blnFieldGreen" class="checkMark">
        <div class="checkmark_circle"></div>
        <div class="checkmark_stem"></div>
        <div class="checkmark_kick"></div>
      </span>
    </label>
  </ng-container>
  <div *ngIf="blnRenderMenu">

  </div>

  <div class="error-msg" *ngIf="blnShowError && errorMessage &&  errorMessage.length > 0; else generic_error" >
    <div class="text-danger">
      {{ errorMessage }}
    </div>
  </div>
  <ng-template #generic_error>
    <div *ngIf="blnShowError">
    <div class="text-danger" *ngIf="invalidEmailError===true">
      Invalid {{ labelName }} 
     </div>
    <div *ngIf="ifInvalidEmailErrorGiven===false" 
        [ngClass]=" [placeholderName] == 'Enter your username' || [placeholderName] == 'Enter your password' ? 'text-danger-login' : 'text-danger'"
       >
      {{ labelName }} Required
    </div>
    </div>
  </ng-template>
  <div class="result-section" *ngIf="blnShowResult">
    <b>{{ labelName }}</b><br />
    <div *ngIf="fieldType !== 'password'">
      <div *ngIf="formGroup.get(controlName).value !== ''">
        {{ formGroup.get(controlName).value }}
      </div>
      <div *ngIf="formGroup.get(controlName).value === ''">
        N/A
      </div>
    </div>
    <div *ngIf="fieldType === 'password'">
      ************
    </div>
  </div>